import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';
@Injectable({
  providedIn: 'root'
})

export class CloseService {

  // private ip = 'http://35.197.141.96:3800';

  constructor(
    private httpClient: HttpClient
  ) { }


  public getAvanceEncuestaMedir(data,banderaid?){
    if(banderaid){
      console.log("Desde status encuesta");
      let idEmpresa= localStorage.getItem('idEmpresa_surveysatus');
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medir.cierre.getAvanceEncuesta+idEmpresa,data);
    }else{

      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medir.cierre.getAvanceEncuesta+this.getCompanyID(),data);
    }

    //return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medir.cierre.getAvanceEncuesta+this.getCompanyID(),data);
    
    // return this.httpClient.post(this.ip+'/api_empresa/getAvanceEncuesta/'+this.getCompanyID(),data,
    //{ headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public setCierreMedir(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medir.cierre.setCierre+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Certificar/terminar/'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  private getCompanyID():string{
    const token = localStorage.getItem('companyID');

    return token;
  }


  ////////////////OBTIENE EL TOKEN DEL USUARIO EN LINEA
  private getToken():string{
    const token = localStorage.getItem('token');

    return token;
  }


}
